import * as React from 'react'

const SvgChevronSortUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.5l4.375 4.375-.875.875-3.5-3.5-3.5 3.5-.875-.875L10 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronSortUpIcon
